var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearnMoreArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.39 6.70461C10.3197 6.63431 10.2243 6.59482 10.1249 6.59482C10.0255 6.59482 9.93009 6.63431 9.85977 6.70461L9.32952 7.23486C9.25922 7.30519 9.21973 7.40055 9.21973 7.49999C9.21973 7.59942 9.25922 7.69479 9.32952 7.76511L13.5644 12L9.32952 16.2349C9.25922 16.3052 9.21973 16.4006 9.21973 16.5C9.21973 16.5994 9.25922 16.6948 9.32952 16.7651L9.85977 17.2954C9.93009 17.3657 10.0255 17.4052 10.1249 17.4052C10.2243 17.4052 10.3197 17.3657 10.39 17.2954L15.4203 12.2651C15.4906 12.1948 15.5301 12.0994 15.5301 12C15.5301 11.9006 15.4906 11.8052 15.4203 11.7349L10.39 6.70461Z",
    fill: "#1E2DBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnMoreArrow);
export default __webpack_public_path__ + "static/media/learnMoreArrow.5ac09721e0e25eba43702042c040ac74.svg";
export { ForwardRef as ReactComponent };